__turbopack_context__.v({
  "alert": "Alert-module__DM6GDW__alert",
  "global": "Alert-module__DM6GDW__global",
  "icon": "Alert-module__DM6GDW__icon",
  "icon-error": "Alert-module__DM6GDW__icon-error",
  "icon-success": "Alert-module__DM6GDW__icon-success",
  "icon-warning": "Alert-module__DM6GDW__icon-warning",
  "iconContainer": "Alert-module__DM6GDW__iconContainer",
  "kind-error": "Alert-module__DM6GDW__kind-error",
  "kind-info": "Alert-module__DM6GDW__kind-info",
  "kind-success": "Alert-module__DM6GDW__kind-success",
  "kind-warning": "Alert-module__DM6GDW__kind-warning",
});
